import React from 'react';

import { Update } from 'src/shared/types/update';

import ProductUpdatesItemRow from './ProductUpdatesItemRow';

interface ProductUpdatesListProps {
  updates: Update[];
}

const ProductUpdatesList: React.FC<ProductUpdatesListProps> = ({ updates }) => {
  const renderUpdates = () => {
    return updates.map((update) => (
      <ProductUpdatesItemRow key={update?.id} update={update} />
    ));
  };

  return (
    <div>
      <div className="flex flex-col">{renderUpdates()}</div>
    </div>
  );
};

export default ProductUpdatesList;
